import React from "react";
import { Link } from "react-router-dom";
import LegalLayout from "./LegalLayout";

export default function Refund() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Refund Policy"
      intro="How refunds, revisions and cancellations work for custom CAD commissions."
      lastUpdated="20 July 2026"
      path="/refund-policy"
    >
      <p>
        Every GetJewelDesigns order is <strong>bespoke, made-to-order digital work</strong> produced to your
        brief. This policy explains when refunds apply. It should be read together with our{" "}
        <Link to="/terms">Terms & Conditions</Link>.
      </p>

      <h2>1. Free until you approve</h2>
      <p>
        Submitting a brief and receiving a quotation is free and carries no obligation. You are only
        charged once you approve a quotation, and paid work begins only after payment is confirmed. If
        you never approve a quotation, there is nothing to refund.
      </p>

      <h2>2. Revisions come first</h2>
      <p>
        Because the work is subjective and iterative, our primary remedy is <strong>revision, not
        refund</strong>. Each quotation includes a defined number of revisions covering reasonable
        changes to the approved requirements. If a delivered draft does not match the agreed brief, tell
        us within the review window and we will revise it. Most concerns are resolved this way.
      </p>

      <h2>3. When you may be eligible for a refund</h2>
      <ul>
        <li><strong>Before work starts</strong> — if you cancel an order after payment but before any design work has begun, you are eligible for a full refund less any non-recoverable payment-processing fees.</li>
        <li><strong>Non-delivery</strong> — if we fail to deliver an initial draft within a reasonable time beyond the estimated turnaround and cannot agree a new date with you, you may request a refund of amounts paid for the undelivered work.</li>
        <li><strong>Work not as described</strong> — if the delivered work materially fails to meet the approved brief and cannot be corrected within the included revisions (or a reasonable further attempt), you may request a partial or full refund at our reasonable discretion.</li>
      </ul>

      <h2>4. When refunds are not available</h2>
      <ul>
        <li>Change of mind after final files have been approved and delivered.</li>
        <li>Requests for changes outside the originally approved scope (these are quoted separately).</li>
        <li>Delays or failures caused by incomplete, inaccurate or infringing information you provided, or by not responding during the revision process.</li>
        <li>Dissatisfaction with an outcome that matches the approved brief and specifications.</li>
      </ul>

      <h2>5. How to request a refund</h2>
      <p>
        Email <a href="mailto:getjeweldesigns@gmail.com">getjeweldesigns@gmail.com</a> (or use our{" "}
        <Link to="/contact">contact page</Link>) with your order reference and a short description of the
        issue. We aim to acknowledge requests within <strong>two (2) business days</strong> and to resolve
        them within <strong>seven (7) business days</strong> of acknowledgement.
      </p>

      <h2>6. How approved refunds are paid</h2>
      <p>
        Approved refunds are issued to the original payment method through our payment processor,
        <strong> Razorpay</strong>. Once approved, refunds are initiated within two (2) business days;
        the time for funds to appear then depends on your bank or card issuer (typically 5–7 business
        days). Where a refund is partial, we will explain how the amount was calculated.
      </p>

      <h2>7. Chargebacks</h2>
      <p>
        Please contact us first — most issues are resolved quickly. Raising a chargeback before
        contacting us may delay resolution and can result in account suspension while the dispute is
        investigated.
      </p>

      <h2>8. Your statutory rights</h2>
      <p>
        Nothing in this policy affects rights you have under mandatory consumer-protection law in your
        country. Where such law grants stronger rights, those rights apply.
      </p>

      <h2>9. Contact</h2>
      <p>
        Questions about refunds? Reach us at <a href="mailto:getjeweldesigns@gmail.com">getjeweldesigns@gmail.com</a>.
      </p>
    </LegalLayout>
  );
}
